import SingleSelector from '@repo/common/components/SingleSelector/SingleSelector';
import { Button } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import type { ActionBlockType } from '../../pages/AutomationPage/V2/store';
import { useAutomationV2Store } from '../../pages/AutomationPage/V2/useAutomationV2Store';
import { getActionBlockTypeIcon, getActionBlockTypeLabel } from './utils';

export const AddAutomationActionButtonV2 = observer(() => {
	const store = useAutomationV2Store();

	const target = <Button leftIconName="plus">Add action</Button>;

	const actionMenuOptions = useMemo(
		() =>
			store.remainingActionBlocks.map((blockType) => ({
				value: blockType,
				label: getActionBlockTypeLabel(blockType),
				iconName: getActionBlockTypeIcon(blockType),
			})),
		[store.remainingActionBlocks]
	);

	const handleOnClick = (blockType: ActionBlockType) => {
		store.addActionBlockType(blockType);
	};

	return (
		<SingleSelector
			target={target}
			isViewerUser={false}
			searchable={false}
			options={actionMenuOptions}
			property="actions"
			iconType="tabler"
			supportSelected={false}
			onChange={handleOnClick}
		/>
	);
});
